import { Link } from "gatsby"
import * as React from "react"
import { StoreContext } from "../context/store-context"
import { addToCart as addToCartStyle, unavailable, requestBtn } from "./add-to-cart.module.css"

export function AddToCart({ variantId, quantity, available, isUnique, collections, ...props }) {
  const { addVariantToCart, checkout, loading } = React.useContext(StoreContext)
  const [alreadyInCart, setAlreadyInCart] = React.useState(false)

  function addToCart(e) {
    e.preventDefault()
    addVariantToCart(variantId, quantity, isUnique)
    if (isUnique) setAlreadyInCart(true)
  }

  React.useEffect(() => {
    const inCart = lineItem => lineItem.variant.id === variantId
    if (isUnique) {
      if (checkout.lineItems.length===0) {
        setAlreadyInCart(false)
      } else if (checkout.lineItems.some(inCart)) {
        setAlreadyInCart(true)
      } else {
        setAlreadyInCart(false)
      }
    }
  }, [checkout.lineItems])

  return (
    <div>
      <button
        type="submit"
        className={`${addToCartStyle} ${
          available ? ( alreadyInCart ? unavailable : "hoverableBtn") : unavailable}`}
        onClick={addToCart}
        disabled={!available || loading || alreadyInCart}
        {...props}
      >
        { available ? 
          ( alreadyInCart ? "Added to Cart" : "Add to Cart")
        : 
        "Sold Out!" 
        }
      </button>
      {(!available && collections.some(coll=>coll.handle==="fiction" || coll.handle==="nonfiction")) &&
      <Link to="/requests">
      <button className={requestBtn}>Request a Copy</button>
      </Link>
      }
    </div>
  )
}
